import R from 'ramda';

function checkSentenceAccepted(sentenceChange, userId, invites, dealUsers) {
  const accepts = sentenceChange.accepts || [];

  let userIds = R.pluck('invitee', invites);
  const owner = R.find(R.propEq('type', 'owner'))(dealUsers);
  if (owner) {
    userIds.push(owner.user);
  }

  return userIds.every(
    (id) => id && (id === userId || accepts.indexOf(id) !== -1)
  );
}

export default checkSentenceAccepted;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/checkSentenceAccepted.js